import { useEffect, useRef, useState } from "react";

const useDebounce = (value, delay = 300, fn) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const isFirstRun = useRef(true);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      if (isFirstRun.current) {
        isFirstRun.current = false;
      } else {
        if (fn) fn();
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
